<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单 -->
    <div class="form mgt-30 bg-white pdt-20">
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="设备型号">
          <el-select
            v-model="form.equipmentVersion"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="v in typeListArr"
              :key="v.id"
              :label="v.equipmentVersion"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="form.equipmentNum"
            placeholder="请输入设备编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="设备状态">
          <el-select v-model="form.error" placeholder="全部" clearable>
            <el-option label="异常" value="1"></el-option>
            <el-option label="正常" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联网状态">
          <el-select v-model="form.status" placeholder="全部" clearable>
            <el-option label="在线" value="1"></el-option>
            <el-option label="离线" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <!-- <el-form-item label="设备类型">
          <el-select v-model="form.type" placeholder="全部" clearable>
            <el-option label="购买" value="1"></el-option>
            <el-option label="租赁" value="0"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="设备名称">
          <el-input
            v-model="form.name"
            placeholder="请输入设备名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select v-model="form.usingStatus" placeholder="全部" clearable>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <span class="mgr-12 mgl-12">创建时间</span>
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        至
        <el-date-picker
          v-model="form.endTime"
          :picker-options="pickerOptionsEnd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-form-item label="所属分区">
          <el-select
            filterable
            v-model="form.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="mgl-5" type="primary" @click="getList()"
            >查询</el-button
          >
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 合计设备数 -->
    <!-- ======企业设备======= -->
    <div class="equipmentNum">
      <div class="flex  aic title">
        <div class="f16 fw-600 color052154 mgt-20 mgb-20 mgr-50">
          合计设备数：{{ statForm.countNum }}
        </div>
        <div class="f16 fw-600 color052154 mgt-20 mgb-20 mgr-50">
          启用设备数：{{ statForm.usingNum }}
        </div>
        <div class="f16 fw-600 color052154 mgt-20 mgb-20">
          禁用设备数：{{ statForm.notUsingNum }}
        </div>
      </div>

      <btns class="mgb-20" @exec="exec"></btns>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="100"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="name" label="设备名称">
          <template slot-scope="scope">
            <span v-text="scope.row.name ? scope.row.name : '- -'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentVersion" label="设备型号">
        </el-table-column>
        <el-table-column prop="equipmentNum" label="设备编号">
        </el-table-column>
        <!-- <el-table-column prop="typeName" label="铺设模式"> </el-table-column> -->
        <el-table-column prop="typeName" label="所属分区">
          <template slot-scope="scope">
            <span
              v-text="scope.row.regionName ? scope.row.regionName : '- -'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="usingStatus" label="启用状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.usingStatus === 1
                  ? '启用'
                  : scope.row.usingStatus === 0
                  ? '禁用'
                  : '--'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="联网状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.status === 1
                  ? '在线'
                  : scope.row.status === 0
                  ? '离线'
                  : '--'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="error" label="设备状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.setoutStatus == 2
                  ? '排水中'
                  : scope.row.setoutStatus == 1
                  ? '制水中'
                  : scope.row.setoutStatus == 0 &&
                    scope.row.status == 1 &&
                    scope.row.error == '0'
                  ? '正常'
                  : '异常'
              "
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="error" label="故障码">
          <template slot-scope="scope">
            <span v-text="scope.row.error !== '0' ? scope.row.error : '- -'">
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="setoutStatus" label="开关状态">
          <template slot-scope="scope">
            <span
              v-text="Number(scope.row.onoff) === 0 ? '关机' : '开机'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentPlace" label="设备铺设位置">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="endTime" label="到期时间">
          <template slot-scope="scope">
            <span
              v-text="scope.row.typeName == '购买' ? '--' : scope.row.endTime"
            ></span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="timeNum" label="启用天数"> </el-table-column
        ><el-table-column prop="ordernum" label="设备订单量"> </el-table-column
        ><el-table-column prop="money" label="设备交易金额（元）">
        </el-table-column> -->
        <el-table-column fixed="right" label="开关机操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-if="scope.row.onoff === 0"
              @click="on(scope.row)"
              >远程开机</el-button
            >
            <el-button type="text" size="small" v-else @click="off(scope.row)"
              >远程关机</el-button
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handLook(scope.$index, scope.row)"
              >查看详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handEditModel(scope.row)"
              >购水模式编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 分组弹框 -->
    <el-dialog
      title="设备分组"
      :visible.sync="zoneVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="zone">
        <el-form
          ref="zoneForm"
          :rules="rules"
          :model="zoneForm"
          label-width="80px"
        >
          <el-form-item label="分组名称" prop="name">
            <el-select v-model="zoneForm.name" placeholder="请选择分组">
              <el-option
                v-for="v in zoneArr"
                :key="v.id"
                :label="v.regionName"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="zoneVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleFen('zoneForm')"
          >分 配</el-button
        >
      </span>
    </el-dialog>

    <!-- 购水模式编辑弹框 -->
    <el-dialog
      title="购水模式编辑"
      :visible.sync="modelVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="zone">
        <el-form
          ref="modelForm"
          :rules="modelFormRules"
          :model="modelForm"
          label-width="80px"
        >
          <el-form-item label="购水模式" prop="model">
            <el-checkbox-group v-model="modelForm.model" @change="modelChange">
              <el-tooltip
                class="item"
                effect="dark"
                content="微信扫描设备二维码，使用电子水卡支付"
                placement="top-start"
              >
                <el-checkbox label="电子水卡购水" name="1"></el-checkbox>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="微信扫描设备二维码，使用微信支付"
                placement="top-start"
              >
                <el-checkbox label="扫码零售购水" name="2"></el-checkbox>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="使用实物水卡在设备上刷卡"
                placement="top-start"
              >
                <el-checkbox label="实体水卡购水" name="3"></el-checkbox>
              </el-tooltip>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="modelVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleModelEdit('modelForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleAlert, handleConfirm } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数

      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      typeListArr: [], //型号下拉
      statForm: {
        countNum: 0,
        usingNum: 0,
        notUsingNum: 0,
      },
      multipleSelection: [],
      zoneVisible: false,
      zoneForm: { name: "" },
      rules: {
        name: [{ required: true, message: "请选择分组", trigger: "blur" }],
      },
      modelFormRules: {
        model: [{ required: true, message: "请选择购水模式", trigger: "blur" }],
      },
      zoneArr: [],
      modelVisible: false,
      modelForm: {
        model: [],
      },
      id: null,
    };
  },
  created() {
    this.getList();
    this.getTypeList();
    this.getNum();
    this.getZonePull();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    priceEdit() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      if (this.multipleSelection[0].status == 0) {
        handleAlert("设备离线中，暂不支持编辑", "error");
        return;
      }
      this.$api.shebei
        .priceDetailNew({ id: this.multipleSelection[0].id })
        .then((res) => {
          console.log(res, "设备详情啊");
          if (res.code === 200) {
            this.$router.push({
              path: "/shebei/shebeiPriceEdit",
              query: {
                list: res.data,
                futureBatchId: res.data.futureBatchId,
                createTime: res.data.createTime,
                source: res.data.equipmentSource,
              },
            });
          }
        });
    },
    // 开关机
    on(row) {
      if (row.status === 0) {
        handleAlert("设备未联网，无法操作!", "error");
        return;
      }
      if (row.usingStatus === 0) {
        handleAlert("设备未启用，无法操作!", "error");
        return;
      }
      let arr = [];
      arr.push(row);
      handleConfirm(`确认开启此设备吗`, "info")
        .then(() => {
          this.$api.shebei.on({ equipments: arr }).then((res) => {
            if (res.code === 200) {
              handleAlert("开机成功", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    off(row) {
      if (row.status === 0) {
        handleAlert("设备未联网，无法操作!", "error");
        return;
      }
      if (row.usingStatus === 0) {
        handleAlert("设备未启用，无法操作!", "error");
        return;
      }
      let arr = [];
      arr.push(row);
      handleConfirm(`确认关闭此设备吗`, "info")
        .then(() => {
          this.$api.shebei.off({ equipments: arr }).then((res) => {
            if (res.code === 200) {
              handleAlert("关机成功", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    handEditModel(row) {
      this.modelForm.model = [];
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.modelForm.clearValidate();
      });
      if (row.pattern) {
        let modelArr = row.pattern.split(",");
        modelArr.forEach((v) => {
          if (v == 1) {
            this.modelForm.model.push("电子水卡购水");
          }
          if (v == 2) {
            this.modelForm.model.push("扫码零售购水");
          }
          if (v == 3) {
            this.modelForm.model.push("实体水卡购水");
          }
        });
      }
      this.modelVisible = true;
      this.id = row.id;
    },
    handleModelEdit(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认保存吗?")
            .then(() => {
              let arr = [];
              this.modelForm.model.forEach((v) => {
                if (v == "电子水卡购水") {
                  arr.push(1);
                }
                if (v == "扫码零售购水") {
                  arr.push(2);
                }
                if (v == "实体水卡购水") {
                  arr.push(3);
                }
              });
              this.$api.shebei
                .modelEdit({ id: this.id, type: arr.join(",") })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("保存成功", "success");
                    this.getList();
                    this.modelVisible = false;
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    modelChange(e) {
      console.log(this.modelForm.model);
    },
    enable() {
      let that = this;
      // 启用============
      if (that.multipleSelection.length == 1) {
        console.log(that.multipleSelection);
        let stateArr = [];
        that.multipleSelection.forEach((v) => {
          // if (stateArr.indexOf(v.state) === -1) {
          //   stateArr.push(v.state);
          // }
          if (v.usingStatus === 1) {
            stateArr.push(v);
            console.log(stateArr, "启用");
          } else {
            return;
          }
        });
        let integrityArr = [];
        let numberArr = [];
        let regionArr = [];
        that.multipleSelection.forEach((v) => {
          if (v.futureProcessInfo != "80%" && v.futureProcessInfo != "100%") {
            integrityArr.push(v.equipmentNum);
          } else {
            numberArr.push(v.equipmentNum);
          }
        });
        this.multipleSelection.forEach((v) => {
          if (!v.regionName) {
            regionArr.push(v);
          }
        });
        if (regionArr.length > 0) {
          handleAlert("设备存在未划分区域,无法启用", "error");
          return;
        }
        if (stateArr.length > 0) {
          handleAlert("存在设备已启用，请勿重复操作", "warning");
        } else if (integrityArr.length > 0) {
          that.hint2Visible = true;
          that.text = integrityArr.join();
          that.stateData = "启用";
        } else {
          let idArr = that.multipleSelection.map((v) => {
            return v.id;
          });
          handleConfirm(`确认启用该设备吗？`, "info")
            .then(() => {
              this.$api.shebei
                .startShebeiList({ equipmentIds: idArr })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("设备启用成功", "success");
                    this.getList();
                  }
                });
            })
            .catch(() => {
              handleAlert("取消设备启用", "error");
            });
        }
      } else {
        handleAlert("请选择一个设备启用", "warning");
      }
    },

    disable() {
      let that = this;
      // 禁用==========
      if (that.multipleSelection.length == 1) {
        let stateArr = [];
        that.multipleSelection.forEach((v) => {
          // if (stateArr.indexOf(v.state) === -1) {
          //   stateArr.push(v.state);
          // }
          if (v.usingStatus === 0) {
            stateArr.push(v);
          } else {
            return;
          }
        });
        let numberArr = [];
        that.multipleSelection.forEach((v) => {
          numberArr.push(v.equipmentNum);
        });
        if (stateArr.length > 0) {
          handleAlert("存在设备已禁用，请勿重复操作", "warning");
        } else {
          let idArr = that.multipleSelection.map((v) => {
            return v.id;
          });
          handleConfirm(`确认禁用设备${numberArr.join("\n")}吗？`, "info")
            .then(() => {
              this.$api.shebei
                .endShebeiList({ equipmentIds: idArr })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("设备已禁用", "success");
                    this.getList();
                  }
                });
            })
            .catch(() => {
              handleAlert("取消设备禁用", "error");
            });
        }
      } else {
        handleAlert("请选择一个设备禁用", "warning");
      }
    },

    // 区域下拉
    getZonePull() {
      this.$api.zone.zonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    // 设备分组
    shebeiZone() {
      if (this.multipleSelection.length < 1) {
        handleAlert("请选择需要分组的设备", "warning");
        return;
      }
      this.zoneVisible = true;
      this.zoneForm = { name: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.zoneForm.clearValidate();
      });
    },
    // 分配
    handleFen(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认将设备添加至项目组吗?", "info")
            .then(() => {
              let futureEquipmentWaterDtos = [];
              this.multipleSelection.forEach((v) => {
                futureEquipmentWaterDtos.push({
                  id: v.id,
                  companyName: v.companyName,
                  name: v.name,
                  equipmentNum: v.equipmentNum,
                  equipmentPlace: v.equipmentPlace,
                });
              });
              this.$api.zone
                .handBindShebei({
                  futureEquipmentWaterDtos: futureEquipmentWaterDtos,
                  id: Number(this.zoneForm.name),
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.zoneVisible = false;
                    handleAlert("分配成功", "success");
                    this.getList();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.shebei
        .shebeiList({
          pageNum: this.page,
          pageSize: this.pageSize,
          futureEquipmentVersionId: this.form.equipmentVersion,
          equipmentNum: this.form.equipmentNum,
          error: this.form.error,
          status: this.form.status,
          type: this.form.type,
          usingStatus: this.form.usingStatus,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          name: this.form.name,
          regionId: this.form.fenqu,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 统计
    getNum() {
      this.$api.shebei.numStat().then((res) => {
        if (res.code === 200) {
          this.statForm = res.data;
        }
      });
    },

    getTypeList() {
      this.$api.shebei.typeList().then((res) => {
        console.log(res, "型号下啦");
        if (res.code === 200) {
          this.typeListArr = res.data;
        }
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 重置
    resetForm() {
      this.form = { startTime: "", endTime: "" };
      this.getList();
    },
    // 查看详情点击跳转
    handLook(index, row) {
      // if (row.type === "购买") {
      //   this.$router.push("/equipment/equipmentList/detailbuy");
      // } else if (row.type === "租赁") {
      //   this.$router.push("/equipment/equipmentList/detaillease");
      // }
      this.$router.push({
        path: "/shebei/shebeilist/detail",
        query: {
          id: row.id,
          futureCustomerId: row.futureCustomerId,
        },
      });
    },

    // 根据条件判断字段颜色
    cellStayle(row, colum, rowIndex, columnIndex) {
      if (row.row.status === 1 && row.columnIndex == 8) {
        return "color:green";
      } else if (row.row.status === 0 && row.columnIndex == 8) {
        return "color:red";
      } else {
        return;
      }
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
// 顶部选择项
.select {
  .firm-btn {
    padding: 10px 70px;
    background: var(--card-bg);
    border: 1px solid var(--input-border);
    margin-right: 100px;
    cursor: pointer;
  }
  .firm-btn-active {
    padding: 10px 70px;
    background: var(--accent);
    border: 1px solid var(--accent);
    margin-right: 100px;
    color: #fff;
    cursor: pointer;
  }
  .agency-btn {
    padding: 10px 70px;
    background: var(--card-bg);
    border: 1px solid var(--input-border);
    cursor: pointer;
  }
  .agency-btn-active {
    padding: 10px 70px;
    background: var(--accent);
    border: 1px solid var(--accent);
    color: #fff;
    cursor: pointer;
  }
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
// 事件范围框
.el-range-editor.el-input__inner {
  width: 250px;
}
.el-input,
.el-select {
  width: 250px;
}
.equipmentNum .title .el-button {
  height: 30px;
}

.zone {
  .el-input,
  .el-select {
    width: 100%;
  }
}
</style>
